import { Modal } from '@pmi/dsm-react';
import { User } from '../../../../../../shared/models/UserModels';
import RegisteredUsers from './RegisteredUsers';

export default function ResendInvitesModal({
  selectedUsers,
  onSubmit,
  onCancel,
}: {
  selectedUsers: User[];
  onSubmit: (e: Event | any) => void;
  onCancel: () => void;
}) {
  const onResend = (e: Event | any) => {
    onSubmit(e);
  };
  return (
    <Modal
      buttons={[
        {
          titleText: 'Cancel',
          variant: 'outline-secondary',
          onClick: onCancel,
        },
        { titleText: 'Resend Invite', variant: 'primary', onClick: onResend },
      ]}
      onClose={onCancel}
      variant="dialog"
      headline="Resend Invites"
      description="Allows resending of any pending invitations for the selected users with any users selected who are already registered to be ignored."
      show
    >
      <p>
        {selectedUsers.length} user account{selectedUsers.length > 1 ? 's' : ''}
        will have invitations resent.
      </p>
      <RegisteredUsers users={selectedUsers} />
    </Modal>
  );
}
